export const STORE_KEY = 'settings-invitationsTable';
export const HIDE_CONFIRM_INVITATION_STORE_KEY = 'hide_confirm_invitation_modal';

export const BadgeSize = {
  REGULAR: 'regular',
  A6: 'A6',
};

export const EXPORT_STATES_AND_MESSAGES = {
  SUCCESS: 'Your data export finished.',
  ERROR: 'Your data export failed. Please try again.',
  IN_PROGRESS: 'Your data export is in progress. You will be emailed the results.',
  DEFAULT_MESSAGE:
    'Your data export has been requested. Processing will begin shortly. You will be emailed the results.',
};

export const CSV_VALIDATION_ERRORS = {
  HEADER: 'CSV_HEADER_VALIDATION_ERROR',
  MALFORMED: 'CSV_MALFORMED_ERROR',
  VALIDATION: 'CSV_DATA_VALIDATION_ERROR',
};

export const INVITATIONS_DEFAULT_MIN_CELL_WIDTH = 68;

export const PAGINATION_ROW_OPTIONS = [10, 25, 50, 100];

export const INVITATIONS_PREFERENCES = 'settings-invitations-preferences';

export const INVITATIONS_FORBIDDEN_COLUMNS = ['select', 'contextMenu', 'name'];
